import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { IResponse } from 'src/app/shared/models/app';
import { CacheResolverService } from '../cache/cache-resolver.service';
import { CacheConstant } from '../cache/cache.constant';
import { ConfigApi } from '../constants/api.constant';
import { AppConstant, ErrorConfig, Messages, _staticDataItems } from '../constants/app.constant';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class StaticService extends BaseService {

  
  _staticDataItems = { 
    uoms: 'uoms', 
    applicationPreferences: 'applicationPreferences', 
    messages: 'messages', 
    productTypes: 'productTypes', 
    reasonRefs: 'reasonRefs', 
    requestSources: 'requestSources', 
    statRefs: 'statRefs', 
    timezones: 'timezones', 
    typeGroups: 'typeGroups', 
    typeRefs: 'typeRefs' 
  };
  
  service = {};

  constructor(
    private cache: CacheResolverService,
    protected http: HttpClient

  ) {
    super(http);
  }

  /***************Helper Methods Implementation*********************/


  loadStaticData() {
    const url = super.serviceUrl(this.apiConfig.config, ConfigApi.StaticData)

    return super.post(url, { appTypeCodes: [1] }).pipe(
      map((response: any) => {
        if (!response.hasError) {
          this.cache.set(CacheConstant.LocalStorage.StaticData, response.data)
        }
        return response;
      })
    );
  }
  getTypeRefsByGroupCode(typeGroupCode: any, orderByProperty: any) {
    let groupTypeRefs = null;


    return groupTypeRefs;
  }

  init() {
    this.getStaticData();
  }
  getStaticData() {

  }
  getStaticDataItem(itemName: any) {
    let item = null;
    let staticData = this.cache.get(CacheConstant.LocalStorage.StaticData);

    if (staticData && staticData[itemName]) {
      item = staticData[itemName];
    }

    return item;
  }

  getApplicationPreference(key: any) {
    let applicationPreference = null;
    let _applicationPreferences = this.getStaticDataItem(this._staticDataItems.applicationPreferences);

    if (_applicationPreferences && _applicationPreferences.length > 0) {
      applicationPreference = _applicationPreferences
        .find(
          (item: any) => item.preferenceKey === key
        );
    } 
    return applicationPreference;
  }
  
  getMessage(key: any, setDefaultMessageIfNotExist: any) {
    let message = null;
    let _messages = this.getStaticDataItem(_staticDataItems.messages);

    if (_messages && _messages.length > 0) {
      message = this.getMessageById(key);
    }

    if (message === null && (setDefaultMessageIfNotExist || key === "SYSERR")) {
      let sysErrorMessage = this.getMessageById(ErrorConfig.SysErrId);
      message = !sysErrorMessage ? Messages.GenericErrorMessage : sysErrorMessage;
    }

    return message;
  }

  getMessageById(key: any) {
    return (this.getStaticDataItem(_staticDataItems.messages))
    .find(  (item: any)=>  item.messageId === key && item.activeFlag === true );
  }
}
